<template>
<CheckTaxPaymentBalToGL/>
</template>

<script>
import CheckTaxPaymentBalToGL from '../../../components/Gl/CheckTaxPaymentBalToGL/CheckTaxPaymentBalToGL.vue';

export default {
  components: {
    CheckTaxPaymentBalToGL,
  },
};

</script>
